import { RouterProvider } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { SonnerToaster } from '@/components/ui/sonner'
import { ConfirmProvider } from '@/components/ui/confirm-provider'
import { router } from '@/routes'
import { queryClient } from '@/lib/query-client'
import { initSentry } from '@/lib/sentry'

initSentry()

export const App = () => (
  <QueryClientProvider client={queryClient}>
    <ConfirmProvider>
      <RouterProvider router={router} />
      <SonnerToaster />
      {import.meta.env.DEV && <ReactQueryDevtools />}
    </ConfirmProvider>
  </QueryClientProvider>
)
